export default "__VITE_ASSET__BbgZDeI$__"